import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/layouts/login.vue").then(m => m.default || m))
}